// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentedLink_container__b0AZm"};